import { defineStore } from "pinia";
import { getLanguages, getLocalizedTranslations } from "@/api/apiclient/translations";
import type { TranslationLanguage } from "@/types/translations";
import { getI18n } from "@/plugins/i18n";
import { SessionStorage } from "@/storage/index";
import { getLocalized } from "@/api/apiclient/language";
// import { getI18n, loadLocaleMessages, setI18nLanguage } from "@/i18n";
// import { setLocale } from "@vee-validate/i18n";

// import apiProvider from "api/apiProvider";
// import * as translationsApi from "api/apiclient/translations";
// import { LoadingState } from "types/enums";

// import type * as Api from "types/api";
// import type * as Store from "types/store";
// import { mapTranslationLanguage } from "mappers/translations";
// import config from "config";
// import { localStore } from "core/localStore";

interface State {
  defaultLocale: string;
  currentLocale: string;
  locales: Array<TranslationLanguage>;
  loadingState: string;
  error: unknown;
}

export const useLocale = defineStore("locale", {
  state: (): State => {
    const defaultLocale = "it-IT"; //config.defaultLocale;
    const currentLocale = "it-IT"; //config.defaultLocale;

    return {
      defaultLocale,
      currentLocale,
      locales: [],
      loadingState: "UNSET",
      error: null,
    };
  },
  actions: {
    async init(): Promise<void> {
      // const current = await localStore.getLocale();
      // if (current) {
      //   this.currentLocale = current;
      // }
    },
    async fetchLanguages(): Promise<void> {
      try {
        await getLanguages();
        this.locales = [{ locale: "it-IT", name: "Italiano" }];
      } catch (error: unknown) {
        console.error("fetchLanguages", error);
      }
    },
    async changeLanguage(locale: string) {
      const i18n = getI18n();

      // const list = await getLocalizedTranslations(locale);
      const list = await getLocalized(locale);
      i18n.global.locale.value = locale;
      i18n.global.setLocaleMessage(locale, list);
      SessionStorage.set(["locale"], locale);
      this.currentLocale = locale;
    },
  },
});
